// Hand-maintained operations that intentionally differ from Amplify-generated documents.

export const listTicketsV2 = /* GraphQL */ `
  query ListTicketsV2($input: ListTicketsInput) {
    listTicketsV2(input: $input) {
      tickets {
        taskId
        status
        taskType
        taskCreationTime
        taskSlaTime
        taskAssignmentTime
        taskCompletionTime
        assignedUserId
        completionUserId
        allowCompletion
        taskTitle
        taskTags {
          label
          value
          url
        }
      }
      lastKey
    }
  }
`
